import { createFileRoute } from '@tanstack/react-router'

import { MembersSection } from '@/features/organization/members-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/membros')({
  component: MembrosTab,
})

function MembrosTab() {
  const { currentOrgId } = useAuth()
  return <MembersSection orgId={currentOrgId} />
}
